<template>
  <div
    class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center"
    id="page-login"
  >
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <vx-card ref="loginCard">
        <div slot="no-body" class="full-page-bg-color">
          <div class="vx-row no-gutter justify-center items-center">
            <div class="vx-col hidden lg:block lg:w-1/2">
              <img src="@/assets/images/pages/login.png" alt="login" class="mx-auto" />
            </div>
            <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
              <div class="p-8">
                <div class="vx-card__title mb-8">
                  <h4 class="mb-4">Login</h4>
                  <p>Bem-vindo, faça o login para entrar no sistema.</p>
                </div>
                <cpf-input
                  icon="icon icon-user"
                  icon-pack="feather"
                  label-placeholder="CPF"
                  v-model="username"
                  class="w-full no-icon-border"
                  v-on:keyup.enter="login({username, password})"
                  name="username"
                  autocomplete="off"
                />

                <vs-input
                  type="password"
                  icon="icon icon-lock"
                  icon-pack="feather"
                  label-placeholder="Senha"
                  v-model="password"
                  class="w-full mt-6 no-icon-border"
                  v-on:keyup.enter="login({username, password})"
                  name="password"
                />

                <div class="flex flex-wrap justify-between my-5">
                  <!-- <vs-checkbox v-model="checkbox_remember_me" class="mb-3">Lembrar</vs-checkbox> -->
                  <router-link to="/esqueci-senha">Esqueceu sua senha?</router-link>
                </div>

                <div class="flex flex-wrap justify-end my-5">
                  <vs-button v-on:click="login({username, password})">Login</vs-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import CpfInput from "@/components/inputs/CpfInput.vue";

export default {
  components: { CpfInput },
  data() {
    return {
      username: "",
      password: "",
      checkbox_remember_me: false
    };
  },
  created() {
    if (this.$route.query.login) {
      this.$store.commit("SET_LOGIN", JSON.parse(this.$route.query.login));
    }

    if (this.$route.query.usuario) {
      this.$store.commit("SET_USUARIO", JSON.parse(this.$route.query.usuario));
    }
  },
  watch: {
    loading(loading) {
      if (loading) {
        this.$refs.loginCard.refreshcard();
      } else {
        this.$refs.loginCard.removeRefreshAnimation();
      }
    }
  },
  computed: {
    loading() {
      return this.$store.getters.isLoadingLogin();
    }
  },
  methods: {
    login(dados) {
      this.$store
        .dispatch("FETCH_LOGIN_ASYNC", dados)
        .then(response => {
          if (response.data.status) {
            if (response.data.data.usuarioTipo.redirect_login) {
              this.$router.replace(
                `/${response.data.data.usuarioTipo.redirect_login}`
              );
            } else {
              this.$router.replace("/");
            }
          } else {
            throw new Error();
          }
        })
        .catch(() => {
          this.$vs.notify({
            title: "Dados Inválidos",
            text: "Seu usuário ou senha estão incorretos",
            color: "danger",
            iconPack: "feather",
            icon: "icon-alert-circle",
            position: "bottom-center"
          });
        });
    }
  }
};
</script>

<style lang="scss">
</style>
